<template>
  <div class="media-gallery">
    <product-gallery-mobile
      class="visible-xs"
      v-show="gallery.length"
      :gallery="gallery"
      :vimeo-id="vimeoId"
      :product-name="product.name"
      :product-sold="isProductSold"
      :sold-label="soldLabel"
      @toggle="openOverlay"
    />
    <div v-if="isOnline" class="w-100 relative image-box">
      <product-gallery-overlay
        v-if="isZoomOpen"
        :current-slide="currentSlide"
        :product-name="product.name"
        :gallery="large"
        @close="toggleZoom"
      />
      <!-- <no-ssr> -->
      <product-gallery-carousel
        v-if="showProductGalleryCarousel && !$device.isMobile"
        :gallery="gallery"
        :style="style"
        :stylist-notes="stylistNotes"
        :stylist-header="stylistHeader"
        :vimeo-id="vimeoId"
        :configuration="configuration"
        :product-name="product.name"
        :product-sold="isProductSold"
        :sold-label="soldLabel"
        @toggle="openOverlay"
        @close="onEscapePress"
        @loaded="carouselLoaded = true"
      />
      <!-- </no-ssr> -->
    </div>
    <product-image v-else :image="offline" />
  </div>
</template>

<script>
import { ProductGallery } from '@vue-storefront/core/modules/catalog/components/ProductGallery.ts'
import ProductGalleryMobile from 'theme/components/core/ProductGalleryMobile'
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import NoSSR from 'vue-no-ssr'
import ProductImage from './ProductImage'
import { onlineHelper } from '@vue-storefront/core/helpers'
import { isProductSoldOut, getProductSoldLabel } from 'theme/helpers/selling-products'

const ProductGalleryOverlay = () => import(/* webpackChunkName: "vsf-product-gallery-overlay" */ './ProductGalleryOverlay')
const ProductGalleryCarousel = () => import(/* webpackChunkName: "vsf-product-gallery-carousel" */ './ProductGalleryCarousel.vue')

export default {
  components: {
    ProductGalleryCarousel,
    'no-ssr': NoSSR,
    ProductGalleryOverlay,
    ProductImage,
    ProductGalleryMobile
  },
  mixins: [
    ProductGallery,
    onEscapePress
  ],
  watch: {
    '$route': 'validateRoute'
  },
  data () {
    return {
      isZoomOpen: false,
      showProductGalleryCarousel: false,
      currentSlide: 0,
      carouselLoaded: false
    }
  },
  mounted () {
    this.showProductGalleryCarousel = true
  },
  computed: {
    style () {
      return `min-height: ${this.gallery.length / 3 * 575}px`
    },
    isOnline (value) {
      return onlineHelper.isOnline
    },
    isProductSold () {
      return isProductSoldOut(this.product)
    },
    soldLabel () {
      return getProductSoldLabel(this.product)
    }
  },
  methods: {
    openOverlay (currentSlide) {
      this.currentSlide = currentSlide
      this.toggleZoom()
    },
    validateRoute () {
      this.$forceUpdate()
    },
    toggleZoom () {
      this.isZoomOpen = !this.isZoomOpen
    },
    onEscapePress () {
      if (this.isZoomOpen) {
        this.toggleZoom()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.media-gallery {
  text-align: center;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  min-height: calc(90vw * 1.15);

  @media only screen and (min-width:768px) {
    min-height: initial;
    align-items: initial;
  }

  &--loaded {
    background-image: none;
  }
  .image-box {
    @media (max-width: 767px) {
      width: initial;
    }
  }
}
</style>
